var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1826_697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6.41L16.59 5L12 9.58L7.41 5L6 6.41L12 12.41L18 6.41Z",
    fill: "#3287EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13L16.59 11.59L12 16.17L7.41 11.59L6 13L12 19L18 13Z",
    fill: "#3287EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1826_697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirPressure);
export default __webpack_public_path__ + "static/media/air-pressure.50e131298cc6fdaed66929fff40e0943.svg";
export { ForwardRef as ReactComponent };